import { post } from '@/util/http'

// 获取指定组织机构ID下的所有组织机构树形信息
export const selectTreeByRootOrgId = params => post('/sum/sumOrg/selectTreeByRootOrgId', params)

// 获取组织机构列表信息
export const selectListOrg = params => post('/residentOffice/find', params)
// 获取未绑定组织机构列表信息
export const selectListUnboundOrg = params => post('/residentOffice/unbound/find', params)
/**
 * 获取查询机构列表 - 简约版 id - name
 */
export const selectBriefEdition = params => post('/residentOffice/selectBriefEdition', params)

export const selectManageListOrg = params => post('/residentOffice/findManageList', params)
export const create = params => post('/residentOffice/create.json', params)
export const update = params => post('/residentOffice/update.json', params)
export const cancel = params => post('/residentOffice/cancel.json', params)
export const deleted = params => post('/residentOffice/delete.json', params)
export const finishReg = params => post('/residentOffice/finish.json', params)

export const resentativeCreate = params => post('/representative/create.json', params)
export const resentativeUpdate = params => post('/representative/update.json', params)
export const resentativeDeleted = params => post('/representative/delete.json', params)
export const resentativeFind = params => post('/representative/find.json', params)

export const chineseEmployeeCreate = params => post('/chineseEmployee/create.json', params)
export const chineseEmployeeUpdate = params => post('/chineseEmployee/update.json', params)
export const chineseEmployeeDeleted = params => post('/chineseEmployee/delete.json', params)
export const chineseEmployeeFind = params => post('/chineseEmployee/find', params)
